import { useHistory } from 'react-router-dom'
import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    const history = useHistory()
    const items = [
        {
            text: "Parâmetros Técnicos",
            url: "/rins/parametrosTecnicos"
        },
        {
            text: "Posição do Paciente",
            url: "/rins/posicaoPaciente"
        },
        {
            text: "Programação",
            url: "/rins/linhasReferencia"
        },
        {
            text: "Reformatações Multiplanares",
            url: "/rins/reformatacoesMultiplanares"
        },
        {
            text: "Protocolos de Pós-processamento",
            url: "/rins/reformatacoes"
        },
        {
            text: "Back-up",
            url: "/rins/reformatacoes/backup"
        },
        {
            text: "Documentação",
            url: "/rins/reformatacoes/documentacao"
        }
    ]
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Tomografia Computadorizada Multislice Rins e vias urinárias / Urotomografia Sem Contraste I.V.</Title>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-10">
                    {
                        items.map(item => (
                            <button
                                key={item.url}
                                className="btn btn-info btn-block my-4"
                                onClick={
                                    () => history.push(`/tronco${ item.url }`)
                                }
                            >{ item.text }</button>
                        ))
                    }
                </div>
            </div>
        </Container>
    )
}